import React from "react";
import styled from "styled-components";

import DataTable from "./DataTable";
import { ReportItem } from "./DataTable/lib/DataTable.type";
import { StringParser } from "./StringParser";
import Table from "./Table";

interface OwnProps {
    data: ReportItem[];
}

const MarkdownParsing = ({ data }: OwnProps) => {
    const renderItem = (item: ReportItem, index: number) => {
        const key = `${index}-${item?.option}`;

        switch (item?.option) {
            case "#":
                return <SectionTitleH1 key={key}>{StringParser(item.value)}</SectionTitleH1>;
            case "##":
                return <SectionTitleH2 key={key}>{StringParser(item.value)}</SectionTitleH2>;
            case "###":
                return <SectionTitleH3 key={key}>{StringParser(item.value)}</SectionTitleH3>;
            case "####":
                return <SectionTitleH4 key={key}>{StringParser(item.value)}</SectionTitleH4>;
            case "---":
                return <Divider key={key} />;
            case "table":
                return <Table key={key} value={item.value} />;
            case "dataTable":
                return item.fileData ? <DataTable key={key} value={item.value} fileData={item.fileData} /> : null;
            case "blockquote":
                return <Blockquote key={key}>{StringParser(item.value)}</Blockquote>;
            case 'warning':
                return <WarningMessage key={key}>{StringParser(item?.value)}</WarningMessage>;
            case "p":
            default:
                return <DefaultText key={key}>{StringParser(item.value)}</DefaultText>;
        }
    };

    return <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>{data.map(renderItem)}</div>;
};

const SectionTitleH1 = styled.h1`
    font-size: 22px;
    font-weight: 700;
    line-height: 140%;
    padding: 4px 0;
    min-height: 31px;
`;

const SectionTitleH2 = styled.h2`
    font-size: 20px;
    font-weight: 700;
    line-height: 140%;
    padding: 4px 0;
    min-height: 28px;

    color: black;
`;

const SectionTitleH3 = styled.h3`
    font-size: 18px;
    font-weight: 700;
    line-height: 140%;
    padding: 4px 0;
    min-height: 25px;

    color: #2275ee;
`;

const SectionTitleH4 = styled.h4`
    font-size: 16px;
    font-weight: 700;
    line-height: 140%;
    padding: 4px 0;
    min-height: 22px;

    color: #2275ee;
`;

const DefaultText = styled.div`
    font-size: 16px;
    font-weight: 400;
    line-height: 140%;
    min-height: 22px;
`;

const Blockquote = styled.blockquote`
    padding: 1px 8px;
    border-left: 3px solid #b1d0ff;
    font-style: italic;
    font-size: 16px;
    margin-top: 18px;
    margin-bottom: 8px;
    min-height: 22px;
`;

const Divider = styled.div`
    margin: 12px 0;
    border-bottom: 1px solid #c3c3c3;
`;

const WarningMessage = styled.div`
    padding: 8px;
    background-color: #f0f0f0;
    color: #8d8d8d;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
`

export default MarkdownParsing;
